import {
	faAngleDoubleDown,
	faAngleDoubleUp
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NotificationError from 'components/common/notificationsErrors'
import { API_FORMAT_DATE } from 'constants/ApiFormats'
import { Formik } from 'formik'
import { getInitValues } from 'lib/FieldValidations'
import moment from 'moment'
import React, { Component, Fragment } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import FilterInputs from '../FilterInputs'
import styles from './FormFilters.module.scss'
import { IFiltersFormProps } from './FormFiltersType'

class FormFilters extends Component<IFiltersFormProps> {
	render() {
		const { fields, t, idOperacion, initialState, showFilters } = this.props

		const initialValues = fields.length
			? getInitValues(fields, initialState)
			: {}
		const validationSchema = {}

		const classIcon = showFilters ? '' : 'col-sm-1 offset-9'
		const arrowIcon = showFilters ? faAngleDoubleUp : faAngleDoubleDown
		const paddingClass = showFilters ? 'pt-3' : 'pt-1'

		return (
			<Col className={`${styles.containerBorder} ${paddingClass} `} sm={12}>
				<Formik
					initialValues={initialValues}
					onSubmit={(values: any) => {
						const fec_desde =
							values.fec_desde !== ''
								? moment(values.fec_desde).format(API_FORMAT_DATE)
								: ''

						const fec_hasta =
							values.fec_hasta !== ''
								? moment(values.fec_hasta).format(API_FORMAT_DATE)
								: ''

						this.props.handleFilterSearch({ ...values, fec_desde, fec_hasta })
					}}
					validationSchema={validationSchema}
					enableReinitialize={true}
					render={(props) => {
						const {
							values,
							handleChange,
							handleBlur,
							setFieldValue,
							setFieldTouched
						} = props

						return (
							<Fragment>
								<Row>
									<Col sm={12}>
										<NotificationError
											errors={props.errors}
											touched={props.touched}
										/>
									</Col>
									<Col sm={2} className={styles.divLabel}>
										{t('pickStock.filters')}
									</Col>
									<Col className={`text-right ${classIcon}`}>
										<FontAwesomeIcon
											style={{ cursor: 'pointer' }}
											icon={arrowIcon}
											onClick={this.props.toggleFilters}
										/>
									</Col>
								</Row>
								{showFilters && (
									<Form
										onSubmit={(e) => props.handleSubmit(e as any)}
										className="voucher-info-form"
									>
										<FilterInputs
											{...{
												values,
												handleChange,
												handleBlur,
												setFieldValue,
												setFieldTouched,
												fields,
												idOperacion
											}}
										/>

										<Row className={'pb-2 pr-3'}>
											<Col
												sm={{ span: 3, offset: 7 }}
												className={'text-right mt-2'}
											>
												<Button style={{ minWidth: '125px' }} type={'submit'}>
													{t('global.filter')}
												</Button>
											</Col>
											<Col sm={{ span: 1 }} className={'text-right mt-2'}>
												<Button
													style={{ minWidth: '105px' }}
													type={'button'}
													onClick={() => {
														this.props.clearFilters()
														props.resetForm()
													}}
												>
													{'Limpiar'}
												</Button>
											</Col>
										</Row>
									</Form>
								)}
							</Fragment>
						)
					}}
				/>
			</Col>
		)
	}
}

export default withTranslation()(FormFilters)
